import React, { useContext, useEffect, useState } from 'react'
import Head from 'next/head'
import { CreateProfileButton } from '../../components/CreateProfileButton'
import { FilteredJobs } from '../../components/FilteredJobs'
import useTranslation from '../../hooks/useTranslation'
import { SponsoredJobsScreen } from '../../components/SponsoredJobsScreen'
import { ADVERTISER_CATEGORIES, FILTER_ENDPOINT, GET_lOCATION_LIST, LOCATION_ENDPOINT, MICRO_LOCATION_SEARCH } from '../../constants/all'
import { APIGet } from '../../utils/ApiClient'
import { FloatingFilters } from '../../components/FloatingFilters'
import {
  applyHandler,
  redirect,
  sortListBykeyInObject,
  seekersAnalayticOptions,
  structureIds,
  getAsPath,
  multipleGetCalls,
  getMethod
} from '../../utils/functions'
import { Breadcrumbs } from '../../components/Breadcrumbs'
import { Media } from '../../commonComponents/Media'
import { DesktopListingFilter } from '../../components/DesktopListingFilter'
import { trackEvent } from '../../analytics'
import { seekersPageScripts } from '../_app'
import { useRouter } from 'next/router'
import Cookies from 'universal-cookie'
import { QuickAccessFooter } from '../../components/QuickAccessFooter'
import { Footer } from '../../components/Footer'
import { DesktopSeekerFooter } from '../../components/DesktopSeekerFooter'
import { CustomerServices } from '../../commonComponents/HomePageComponents'
import { useRouterHook } from '../../hooks/useRouterHook'
import { PopularCategories } from '../../components/PopularCategories'
import { UserSearchedComponent } from '../../components/UserSearchedComponent'
import { BreadCrumbs } from '../../commonComponents/BreadCrumbs'
import { SharedContext } from '../../context/SharedContext'
import { SeekerContext } from '../../context/SeekerContext'

const JobFiltering = ({ footerCategories, footerLocations, params, query, cityLocations, jobCategories }) => {
  const translation = useTranslation()
  const {location:cityLocation, category:selectedCategory} = query;

  const {
    location,
    loginDetails,
    cookie,
    setShowToast,
    windowSize,
    utmParams,
    setUtmParams
  } = useContext(SharedContext);
  
  const {
    showSponsoredJobs,
    setShowSponsoredJobs,
    setLogInOpen,
    filterTitleIds,
    setFilterTitleIds,
    setIsJobProfileCreated,
    setBody,
    body,
    setCurrentPage
  } = useContext(SeekerContext);
  const [Window, setWindow] = useState()
  const [hydrated, setHydrated] = useState(false)
  const [floatingFiltersData, setFloatingFiltersData] = useState([])
  const [selectedFilter, setSelectedFilter] = useState('')
  const [sortedFiltersData, setSortedFiltersData] = useState([])
  const [jobsCount, setJobsCount] = useState('')
  const [popularConfigurationData, setPopularConfigurationData] = useState({});
  const { navigateToPagesInSeeker } = useRouterHook()

  const router = useRouter()

  const isNoFilterSelected =
    getAsPath({ selectedOptions: body?.selectedOptions, filterTitleIds }) == 'jobs-near-me'

  const createProfileHandler = async () => {
    trackEvent({
      name: 'tap_create_profile',
      searchParams: {
        ...utmParams
      },
      options: {
        ...seekersAnalayticOptions(window, loginDetails, location, 'tap', 'listings_page'),
        source: 'listings_page'
      },
      isSeeker: true
    })
    if (!loginDetails?.isLogIn) {
      setLogInOpen(true)
      return true
    } else {
      if (loginDetails?.id) {
        const user = await cookie.get('user')
        if (!user) cookie.set('user', loginDetails.id)
      }
      return await redirect({
        loginDetails,
        cookie,
        setShowToast,
        setIsJobProfileCreated
      })
    }
  }

  const focusHandler = () => {
    const element = document?.getElementById('0_floating_filters')
    element?.scrollIntoView({ behavior: 'smooth' })
  }

  const getFloatingFiltersDataHandler = async () => {
    const data = await APIGet(FILTER_ENDPOINT, { 'App-Type': 'web' })
    if (Object?.keys(filterTitleIds)?.length <= 0) {
      const result = structureIds(data)
      setFilterTitleIds({ ...result })
    }
    setFloatingFiltersData(data)
  }

  const getPopularConfigurationData = async (city_id) => {
    const data = await getMethod(
      {
        url:  `${process.env.NEXT_PUBLIC_BASE_URL_ADS}${GET_lOCATION_LIST}${city_id}/popular-configuration`,
        isAndroidWebview: typeof Android != 'undefined'
      }
    );
   
    setPopularConfigurationData(data);
  }

  useEffect(() => {
    if (window) {
      setWindow(window)
    }
    setHydrated(true)
  }, [])

  useEffect(() => {
    if (router.isReady) {
      getFloatingFiltersDataHandler()
      const from = JSON?.parse(localStorage?.getItem('from') || 'false')
      trackEvent({
        name: 'listings_page_viewed',
        searchParams: {
          ...(router?.query || {})
        },
        options: {
          ...seekersAnalayticOptions(window, loginDetails, location, 'impression', 'listings_page'),
          source: !!from ? from : router?.query?.from || 'Apply Button'
        },
        isSeeker: true
      })
      setUtmParams(router?.query || {})
    }
  }, [router.isReady])
 
  useEffect(() => {
    const selectedBody = JSON.parse(localStorage.getItem("body"))
    const locationRedirection = async () => {
      const Location = await JSON.parse(localStorage.getItem('location'))
      if (!Location) {
        navigateToPagesInSeeker({ pathName: 'locationSelectionPage', as: 'location' })
      }
    }
    if(cityLocation && cityLocation !== "undefined"){
      const matchedLocation = cityLocations?.find(city => city?.title.toLowerCase() === cityLocation.toLowerCase());

      if(matchedLocation){
        localStorage.setItem("location",JSON.stringify(matchedLocation))
      }
    }else{
      locationRedirection()
    }

    if(cityLocation && selectedCategory){
      const matchedCategory = jobCategories?.find(category => (category?.title).replace(/ /g, '')
      ?.replace(/\//g, '-and-')
      ?.replace('&', '-and-')?.toLowerCase() === selectedCategory.toLowerCase())
      if(matchedCategory){
        localStorage.setItem("body",JSON.stringify({...selectedBody, selectedOptions: { ...selectedBody?.selectedOptions, ...{37:[matchedCategory]} }}))
      }
    }
   
  }, [])

  useEffect(() => {
    let sortedData1 = []
    let sortedData2 = []
    const filterData = sortListBykeyInObject({ list: floatingFiltersData?.filters, key: 'title' })
    if (windowSize < 640) {
      for (let itr = 0; itr < filterData.length; itr++) {
        if (body?.selectedOptions?.[filterData?.[itr]?.id]?.length > 0) {
          sortedData1.push(filterData?.[itr])
          sortedData1.sort(
            (a, b) =>
              body?.selectedOptions?.[b?.id]?.length - body?.selectedOptions?.[a?.id]?.length
          )
        } else {
          sortedData2.push(filterData?.[itr])
        }
      }
      setSortedFiltersData(sortedData1.concat(sortedData2))
      setSortedFiltersData(p=>{
        return p.filter(i=>i.title!='Location' && i.title!='Freshness')
      })
      focusHandler()
    } else {setSortedFiltersData(filterData)
      setSortedFiltersData(p=>{
        return p.filter(i=>i.title!='Location' && i.title!='Freshness')
      })
      }
  }, [body?.selectedOptions, floatingFiltersData])

  useEffect(()=>{
    if(location?.city_id || location?.id)
    getPopularConfigurationData(location?.city_id || location?.id)
  },[location?.city_id,location?.id])

  if (!hydrated) {
    return seekersPageScripts()
  }

  return (
    <>
      <Head>
        <title>
          {isNoFilterSelected
            ? translation.formatString(translation.jobsNearMeTitle, {
                numberOfJobs: jobsCount
              })
            : translation.formatString(translation.jobsTitle, {
                location: location?.title || location?.name,
                host: typeof Window != undefined && Window?.location?.origin
              })}
        </title>
        <meta
          name="description"
          content={
            isNoFilterSelected
              ? translation.formatString(translation.jobsDescription, {
                  Location: location?.title || location?.name
                })
              : translation.formatString(translation.jobsMetaData, {
                  location: location?.title || location?.name,
                  host: typeof Window != undefined && Window?.location?.origin
                })
          }
          key="desc"
        />
      </Head>
      {seekersPageScripts()}
      {showSponsoredJobs ? (
        <SponsoredJobsScreen setShowSponsoredJobs={setShowSponsoredJobs} />
      ) : (
        <>
          <div className=" sm:bg`-[#F9F9F9] bg-[#F8F8F8]" id="jobs_listing_container">
            <Media at="sm">
              {
                <div className="w-[100%] bg-[#F8F8F8]" id="create_profile_button">
                  <CreateProfileButton onClick={createProfileHandler} />
                </div>
              }
            </Media>
            <div className="sticky top-[44px] z-20 w-full  bg-[#F8F8F8] sm:top-[80px] sm:pl-[40px] md:pl-[80px]">
              <div
                className="space-y-[12px] bg-[#F8F8F8] px-[12px] py-[12px] sm:space-y-[0px] sm:p-[0px] sm:pt-[20px] sm:pb-[25px]"
                id="jobs_listing_div"
              >
                <BreadCrumbs page = "jobsFiltering" />
                <Media at="sm">
                  <FloatingFilters
                    {...{
                      floatingFiltersData,
                      selectedFilter,
                      setSelectedFilter,
                      sortedFiltersData,
                      setSortedFiltersData
                    }}
                  />
                </Media>
              </div>
            </div>
            <div className="sm:flex sm:space-x-[22px] sm:p-[0px] sm:pl-[32px] md:px-[80px]">
              <Media greaterThan="sm">
                <div className="sticky top-[139px] bg-white sm:w-[224px] md:w-[356px] ">
                  <DesktopListingFilter
                    selectedId={selectedFilter}
                    filterTitles={sortedFiltersData}
                    applyHandler={(body, redirect) => {
                      applyHandler(body, redirect, filterTitleIds, setBody, router, setCurrentPage)
                    }}
                    initialSelectedOptions={body?.selectedOptions}
                  />
                </div>
              </Media>
              <div id="filtered_jobs_container" className="">
                <FilteredJobs {...{ setShowSponsoredJobs }} parameters={params} />
              </div>
            </div>
            <Media at="sm">
              {/* <div className="py-[16px] px-[12px]">
                <UserSearchedComponent keywords = {popularConfigurationData?.keywords} />
              </div> */}
              {popularConfigurationData?.job_categories?.length > 0 && <PopularCategories categories = {popularConfigurationData?.job_categories} />}
            </Media>
            <Media at="sm">
              <QuickAccessFooter />
              <Footer />
            </Media>
            <Media at="md">
              <QuickAccessFooter />
              <Footer />
            </Media>
            <Media greaterThan="md">
              <DesktopSeekerFooter {...{ footerCategories, footerLocations }} />

              <div className="h-fit" style={{ backgroundColor: '#F9F9F9' }}>
                <CustomerServices />
              </div>
            </Media>
          </div>
        </>
      )}
    </>
  )
}

export default JobFiltering

export const getServerSideProps = async (context) => {
  const cookies = new Cookies(context.req.headers.cookie)
  const language = cookies.get('language')
  const apiDetails = [
    {
      url: process.env.NEXT_PUBLIC_BASE_URL_ADS + ADVERTISER_CATEGORIES,
      params: { only_top: 1 },
      header: { 'Accept-Language': language }
    },
    {
      url: process.env.NEXT_PUBLIC_BASE_URL_API + LOCATION_ENDPOINT,
      params: { level: 1 },
      headers: { 'Accept-Language': language }
    },
    {
      url: process.env.NEXT_PUBLIC_BASE_URL_ADS + MICRO_LOCATION_SEARCH,
      params: { q: context?.query?.location },
      headers: {'App-Type': 'web', 'Accept-Language':'en'}
    },
    {
      url: process.env.NEXT_PUBLIC_BASE_URL_ADS + ADVERTISER_CATEGORIES,
      header: { 'Accept-Language': language },
      isTokenPresent: false
    }
  ]

  const res = await multipleGetCalls(apiDetails)

  return {
    props: {
      params: context?.req?.params,
      footerCategories: sortListBykeyInObject({ list: res?.[0], key: 'title' }),
      footerLocations: sortListBykeyInObject({ list: res?.[1]?.results, key: 'title' }).slice(0, 8),
      query: context?.query,
      cityLocations: res?.[2]?.results,
      jobCategories: res?.[3]
    }
  }
}
